import { SignupPage } from 'components/pages/Signup'
import { useRedirectSignedIn } from 'hooks/useRedirectSignedIn'

// /signup is only for signed-out users; signed-in users go to their home page
const Signup = () => {
	const redirecting = useRedirectSignedIn()
	if (redirecting) return null

	return <SignupPage />
}

export default Signup
